// Dropdown.js
import React from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { setCategory } from "./store/slices/dropdownSlice";
import "./DropdownGrid.css"; // New CSS file

const categories = [
  { name: "Hamper Packages", image: "/thedata/WeddingHampers.png" },
  { name: "Kashmiri Dry Fruits", image: "/thedata/kashmiridryfruits.png" },
  { name: "Dry Fruits & Nuts", image: "/thedata/DryFriutsAndNuts.png" },
  { name: "Honey & Saffron", image: "/thedata/KashmiriHoneyAndSaffron.png" },
  { name: "Dates", image: "/thedata/Dates.png" },
  { name: "Stuffed Dates", image: "/thedata/StuffedDates.png" },
  { name: "Seeds", image: "/thedata/Seeds.png" },
  { name: "Kashmiri Fine Baskets", image: "/thedata/KashmiriFineBaskets.png" },
  
];

export default function Dropdown() {
  const dispatch = useDispatch();

  const handleCategoryChange = (categoryValue) => {
    dispatch(setCategory(categoryValue));
  };

  return (
    <div className="dropdown-container">
      <h2 className="dropdown-title">Shop Our Range</h2>
      <div className="category-grid">
       {categories.map((cat, index) => (
  cat.name === "Stuffed Dates" ? (
    <div key={index} className="category-item coming-soon">
      <img
        src={cat.image}
        alt={cat.name}
        className="category-image"
      />
      <div className="category-name">{cat.name}</div>
      <div className="coming-soon-text">Coming Soon</div>
    </div>
  ) : (
    <Link
      key={index}
      to="/pubCategory"
      className="category-item"
      onClick={() => handleCategoryChange(cat.name)}
    >
      <img
        src={cat.image}
        alt={cat.name}
        className="category-image"
      />
      <div className="category-name">{cat.name}</div>
    </Link>
  )
))}

      </div>
    </div>
  );
}
